import React from "react";

export default function TerminalWindow({ children, title = "blackwall", className = "" }) {
  return (
    <div className={`rounded-lg border border-[#262626] bg-[#050505] overflow-hidden ${className}`}>
      <div className="flex items-center gap-1.5 px-4 py-3 border-b border-[#1a1a1a]">
        <div className="w-2.5 h-2.5 rounded-full bg-[#ef4444]/60" />
        <div className="w-2.5 h-2.5 rounded-full bg-[#f59e0b]/60" />
        <div className="w-2.5 h-2.5 rounded-full bg-[#10b981]/60" />
        <span className="ml-3 text-xs font-mono text-[#3f3f46]">{title}</span>
      </div>
      <div className="p-5 font-mono text-sm leading-relaxed">{children}</div>
    </div>
  );
}
